var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table-component",
    {
      ref: "table",
      attrs: {
        data: _vm.paymentData,
        "show-filter": false,
        "table-class": "table",
      },
    },
    [
      _c("table-column", {
        attrs: {
          label: _vm.$t("payments.date"),
          "sort-as": "payment_date",
          show: "formattedPaymentDate",
        },
      }),
      _vm._v(" "),
      _c("table-column", {
        attrs: {
          label: _vm.$t("payments.invoice_num"),
          "sort-as": "invoice_id",
          show: "payable.reference_number",
        },
      }),
      _vm._v(" "),
      _c("table-column", {
        attrs: { label: _vm.$t("payments.payment_num") },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(row.payable.rtgs_number || row.payment_number) +
                    "\n    "
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("table-column", {
        attrs: { label: _vm.$t("general.sent") },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (row) {
              return [
                row.sent_stakeholder
                  ? _c("p", [
                      row.sent_stakeholder.details.company &&
                      row.sent_stakeholder.details.company.name
                        ? _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  row.sent_stakeholder.details.company.name
                                ) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("table-column", {
        attrs: { label: _vm.$t("general.received") },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (row) {
              return [
                row.receiver_stakeholder
                  ? _c("p", [
                      row.receiver_stakeholder.details.company &&
                      row.receiver_stakeholder.details.company.name
                        ? _c("span", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  row.receiver_stakeholder.details.company.name
                                ) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("table-column", {
        attrs: { label: _vm.$t("payments.payment_mode"), show: "payment_mode" },
      }),
      _vm._v(" "),
      _c("table-column", {
        attrs: { label: _vm.$t("payments.amount") },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (row) {
              return [
                _c("span", [_vm._v(_vm._s(_vm.$t("payments.amount")))]),
                _vm._v(" "),
                row.sent_stakeholder.details.currency
                  ? _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$utils.formatMoney(
                            row.amount,
                            row.sent_stakeholder.details.currency
                          )
                        ),
                      },
                    })
                  : _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$utils.formatMoney(
                            row.amount,
                            row.customer.currency
                          )
                        ),
                      },
                    }),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("table-column", {
        attrs: {
          label: _vm.$tc("payments.payment_type", 1),
          show: "payment_type",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }